import styled from "styled-components"

interface ITextProps {
  center?: boolean
  children: React.ReactNode
  primary?: boolean
}

const StyledText = styled.span<ITextProps>`
  color: ${(props) => (props.primary ? props.theme.colors.primary : "inherit")};
  ${(props) => props.center && `text-align: center`};
  font-weight: 700;
`

const Text = (props: ITextProps) => {
  const { children, ...rest } = props
  return <StyledText {...rest}>{children}</StyledText>
}

export { Text }
